// extracted by mini-css-extract-plugin
export default {"modal":"EstudianteNuevoLN_modal__HX9O5","contBotTop":"EstudianteNuevoLN_contBotTop__rNZCU","botCancela":"EstudianteNuevoLN_botCancela__bhbyz","list":"EstudianteNuevoLN_list__hyM8G"};